import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../userInfo/Users.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { MembershipAndSubscriptionDetails } from "src/helper/interfaces";
import Cookies from "js-cookie";
import eye from "../../../assets/img/icons/eye-solid.svg";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import Paginator from "src/components/layout/Paginator";
import bill from "../../../assets/img/icons/marketing-bill-payment-invoice-receipt-svgrepo-com.svg";
import { useBackContext } from "src/hooks/context/BackContext";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import { format } from "date-fns";
import ExportDocs from "src/components/layout/ExportDocs";
import { Link } from "react-router-dom";


const getAllMembershipLeads = async (
   token: string,
   pageNumber: number,
   pageSize: number,
   searchValue: string,
   startDate?: string,
   endDate?: string
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/membership-leads`, {
      headers: {
         "x-access-token": token,
      },
      params: {
         type: "membership",
         pageSize,
         search_value: searchValue,
         start_date: startDate,
         end_date: endDate,
         page: pageNumber
      }

   })
};


const MembershipSales = () => {

   const { isBackClicked } = useBackContext();
   const [hideAllFilters, setHideAllFilters] = useState(false);
   const [membershipLeads, setMembershipLeads] = useState<MembershipAndSubscriptionDetails[]>([])
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");
   const [searchVal, setSearchVal] = useState('');
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;


   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllMembershipLeads(Token, pageNo, pageSize, searchVal, startingDate, endingDate)
            .then((res) => {
               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;
                  setMembershipLeads(data?.data);
                  setTotalPages(res?.data?.data?.totalPages);
                  // dispatch(stopLoading());
               }
               else {
                  Swal.fire({
                     icon: "error",
                     title: "Something went wrong!!",
                     text: `${res?.data?.msg}`,

                  });
                  // dispatch(stopLoading());
               }
            })
            .catch((err: any) => {
               console.log(err);
            })
            .finally(() => {
               dispatch(stopLoading());
            });
      }
   }, [Token, startDate, endDate, searchVal, pageSize, pageNo]);


   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   useEffect(() => {
      if (isBackClicked) {
         setHideAllFilters(!isBackClicked)
      }
   }, [isBackClicked]);

   const handleInvoiceClick = async (id: string, order_type: string) => {
      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: order_type,
            },
         });
         // console.log(res)
         if (res?.data?.status_code === 200) {
            dispatch(stopLoading());
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };
   const doc = new jsPDF();
   doc.text("Subscription Sales Report", 14, 10);
   const formattedData = membershipLeads?.map((item) => {
      return {
         unique_id: item.unique_id,
         sale_id: item._id,
         service_type: item?.service_type,
         // plan_name: item.planDetails?.plan_for,
         worker_name: item?.workerDetails?.name,
         plan_amount: item?.planDetails?.amount,
         worker_type: formatCategory(item?.workerDetails?.worker_type),
         worker_phone: item?.workerDetails?.phone,
         createdAt: format(new Date(item.createdAt), "do MMMM yyyy"),
         expiry: format(new Date(item.membership_validity), "do MMMM yyyy"),
         payment_amount: item.payment_amount,
         is_referralCode_used: item?.is_referralCode_used,
         is_active: item?.is_active,
         yows_commission: item?.yowsComm

      };
   });

   const headers = [
      { label: "Unique ID", key: "unique_id" },
      { label: "Sale ID", key: "sale_id" },
      { label: "Service Type", key: "service_type" },
      // { label: "Plan Name", key: "service_type" },
      { label: "Plan Amount", key: "plan_amount" },
      { label: "Payment Amount", key: "payment_amount" },
      { label: "Worker Name", key: "worker_name" },
      { label: "Worker Type", key: "worker_type" },
      { label: "Worker Phone", key: "worker_phone" },
      { label: "Perchased At", key: "createdAt" },
      { label: "Expiry Date", key: "expiry" },
      { label: "Referral Code Used", key: "is_referralCode_used" },
      { label: "Yows Commision", key: "yows_commission" }
   ];


   const exportPDF = () => {
      const doc = new jsPDF();

      // Sample headers and data
      const tableColumns = [
         "Unique ID",           // unique_id
         "Service Type",        // service_type
         // "Plan Name",
         "Payment Amount",      // payment_amount
         "Worker Name",         // worker_name
         "Worker Phone",        // worker_phone
         "Perchased At",          // createdAt
         "Expiry Date",         // expiry
         "Used Referral",  // is_referralCode_used
         "Yows Commision"

      ];


      const tableData = formattedData.map(item => [
         item.unique_id || "",               // Unique ID  
         item.service_type || "",            // Service Type
         // item.plan_name || "",            // Service Type
         item.payment_amount || 0,           // Payment Amount
         item.worker_name || "",             // Worker Name
         item.worker_phone || "",            // Worker Phone
         item.createdAt || "",               // Created At
         item.expiry || "",                  // Expiry Date
         item.is_referralCode_used ? "Yes" : "No", // Referral Code Used    
         item?.yows_commission 
      ]);

      // Use autoTable with the doc object
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });

      // Save the generated PDF
      doc.save('MembershipSales.pdf');
   };

   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value)
   };

   return (
      <MainLayout
         showAllFilters={hideAllFilters}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}
         // headers={headers}
         // formattedData={formattedData}
         // exportPDF={exportPDF}
      >

         <div className="mt-3 mb-3">

            <div className={` category-main me-2 p-md-4 card`}  >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }

                     <div>
                        <div className="d-flex justify-content-end gap-3 mb-3">
                           <div className="d-flex gap-2">
                              <span className="d-flex align-items-center pagesize-text">
                                 PageSize
                              </span>

                              <select
                                 className="form-select"
                                 style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                 aria-label="Default select example"
                                 value={pageSize} // Bind the value to the state
                                 onChange={handlePageSizeChange} // Handle the change
                              >
                           <option value={10}>10</option>
                                 <option value={20}>20</option>
                                 <option value={50}>50</option>
                                 <option value={100}>100</option>
                                 <option value={200}>200</option>
                              </select>
                           </div>
                           <div>
                              <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />
                           </div>

                        </div>

                        <div className="table-responsive">
                           <table className="table table-striped card-body">
                              <thead>
                                 <tr className="category-tr">
                                    {/* <th scope="col" className="text-start ps-4">Icon</th> */}
                                    <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Worker Type</th>
                              {/* <th scope="col" className="text-start ps-4">Plan Amout</th> */}

                                    <th scope="col" className="text-start ps-4">Paid Amount</th>

                                    <th scope="col" className="text-start ps-4">Worker Name</th>
                                    {/* <th scope="col" className="text-start ps-4">Worker Type </th> */}
                                    <th scope="col" className="text-start ps-4">Phone</th>
                                    <th scope="col" className="text-start ps-4">Perchase Date</th>
                                    <th scope="col" className="text-start ps-4">Referral Used</th>
                              <th scope="col" className="text-start ps-4">Yows Comm.</th>
                                    <th scope="col" className="text-start ps-4">Is Active</th>
                                    <th scope="col" className="text-start ps-4">Valid Till</th>
                                    <th scope="col" className=" ps-4 ">Action</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {
                                    membershipLeads && membershipLeads?.map((data: MembershipAndSubscriptionDetails, i) => {
                                       // const perchaseDate = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                       const perchaseDate = formatDiffrentDate(data?.createdAt);
                                       const membershipValidity = formatDiffrentDate(data?.membership_validity);
                                       const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                       return (
                                          <tr key={data?._id}>
                                             <td className="icon-td align-content-center text-start ps-4">
                                                {rowNumber}
                                             </td>
                                             <td className="text-start align-content-center ps-4">
                                                <span className="">
                                                   {formatCategory(data?.planDetails?.plan_for)}
                                                </span>

                                             </td>

                                             <td className="icon-td align-content-center text-start ps-4">
                                                &#8377; {data?.payment_amount?.toFixed(2)}
                                             </td>

                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.workerDetails?.name}

                                             </td>

                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.workerDetails?.phone}

                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">

                                                {perchaseDate?.formattedDate} <br />{perchaseDate?.formattedHours}
                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.is_referralCode_used ? "True" : "False"}

                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">
                                                &#8377; {data?.yowsComm}

                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.is_active ? "True" : "False"}

                                             </td>
                                             <td className="icon-td align-content-center text-start ps-4">

                                                {membershipValidity?.formattedDate} <br />{membershipValidity?.formattedHours}
                                             </td>

                                             <td className="align-content-center ">
                                                <div className="d-flex justify-content-center gap-3">
                                                   <Link to={`/membership/sales/${data?._id}`}>
                                                      <button className="btn btn-sm delete_btn ">
                                                      <img src={eye} />
                                                   </button>
                                                   </Link>

                                                   <button className="btn btn-sm edit_btn " onClick={() => handleInvoiceClick(data?._id, data?.service_type)} style={{ marginBottom: "1px" }}>
                                                      <img src={bill} alt="invoice" />
                                                   </button>

                                                </div>

                                             </td>
                                          </tr>
                                       )
                                    }
                                    )
                                 }

                              </tbody>
                           </table>

                        </div>
                        <Paginator
                           totalPages={totalPages}
                           pageNo={pageNo}
                           onPageChange={(e, no) => setPageNo(no)}
                           alignment="right"
                        />

                     </div>


            </div>

         </div>

      </MainLayout>
   )

};



export default MembershipSales;